import React, { useEffect, useRef, useState } from 'react';

const Philosophy = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      id="philosophy"
      className="relative py-32 bg-black overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0 opacity-5">
        <img
          src="https://images.unsplash.com/photo-1648337564744-f919c7c2fc02?w=1600"
          alt="Philosophy background"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-transparent to-black" />

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-teal-400 text-sm uppercase tracking-widest font-semibold">Nuestra Filosofía</span>
        </div>

        <div className="space-y-12">
          <div
            className={`transform transition-all duration-1000 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-light text-white leading-tight text-center">
              La educación tradicional enseña{' '}
              <span className="font-bold bg-gradient-to-r from-red-400 to-red-600 bg-clip-text text-transparent">
                obediencia
              </span>
              .
              <br />
              Nosotros enseñamos{' '}
              <span className="font-bold bg-gradient-to-r from-teal-400 to-teal-600 bg-clip-text text-transparent">
                libertad
              </span>
              .
            </h2>
          </div>

          <div
            className={`transform transition-all duration-1000 delay-200 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <p className="text-2xl md:text-3xl text-gray-300 leading-relaxed text-center font-light">
              Aquí no formamos empleados.
              <br />
              <span className="text-white font-medium">Formamos emprendedores.</span>
              <br />
              Pensadores que usan la tecnología como herramienta,
              <br />
              no como cadena.
            </p>
          </div>

          <div
            className={`transform transition-all duration-1000 delay-400 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <p className="text-2xl md:text-3xl text-gray-400 leading-relaxed text-center font-light">
              Porque la verdadera independencia no viene del título,
              <br />
              <span className="text-white font-medium">
                sino de la mente que se atreve a crear.
              </span>
            </p>
          </div>

          <div
            className={`transform transition-all duration-1000 delay-600 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <p className="text-3xl md:text-4xl text-white leading-relaxed text-center font-bold mt-16">
              En Urpe School of Liberty formamos emprendedores, no esclavos.
            </p>
            <p className="text-2xl md:text-3xl text-gray-300 leading-relaxed text-center font-light mt-6">
              Hombres y mujeres libres,
              <br />
              capaces de pensar, construir y prosperar por sí mismos.
            </p>
          </div>
        </div>

        {/* Decorative line */}
        <div className="mt-20 flex justify-center">
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-teal-500 to-transparent" />
        </div>
      </div>
    </section>
  );
};

export default Philosophy;
